import styled from '@emotion/styled'
import { Stack } from '@mui/material'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import React from 'react'
import { NavLink } from 'react-router-dom'

const TabBarNav = styled(Stack)`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0;
  margin-bottom: 2px;
  cursor: pointer;

  &:hover {
    .MuiTypography-root {
      color: #2467f4;
    }
  }

  span {
    position: relative;
  }

  span:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    background: clear;
    height: 2px;
    border-radius: 1px;
  }

  &.active {
    color: #222222;

    span:after {
      background: #115dfc;
    }
  }
`

// Draws a pill shaped underline when the tab is active
const TabBarNavLink = styled(NavLink)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  padding: 8px;
  border-radius: 8px;
  color: #999;

  &:hover {
    background: #e9f0fe;
    font-weight: 500;
    color: #2467f4;
  }

  &.active {
    background: #e9f0fe;
    font-weight: 600;

    span {
      color: #2467f4;
    }
  }
`

export const SubpageTab = ({
  value,
  label,
  isActive,
  onClick,
}: {
  value: number
  label: string
  isActive: boolean
  onClick: (index: number) => void
}) => {
  return (
    <TabBarNav className={isActive ? 'active' : ''} onClick={() => onClick(value)}>
      <span
        style={{
          width: 'fit-content',
        }}>
        {label}
      </span>
    </TabBarNav>
  )
}

export const SubpageTabLink = ({ to, label, end }: { to: string; label: string; end?: boolean }) => {
  return (
    <TabBarNavLink to={to} end={end}>
      <span>{label}</span>
    </TabBarNavLink>
  )
}

SubpageTabLink.defaultProps = {
  end: true,
}

const SubpageTabs = ({ children, orientation }: { children?: React.ReactNode; orientation?: 'row' | 'column' }) => {
  const isMobile = useCheckMobileScreen()
  return (
    <Stack
      direction={orientation || 'column'}
      width={isMobile ? 142 : 216}
      minWidth={isMobile ? 142 : 216}
      spacing="12px">
      {children}
    </Stack>
  )
}

export default SubpageTabs
